// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nPqn","content":"styles_content__1HfVa"};